import { nanoid } from 'nanoid';
import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import FixedView from '../../components/FixedView';
import FormViewer from '../../components/FormViewer';
import FieldItem from '../../components/inputs/FieldItem';
import SelectInput from '../../components/inputs/SelectInput';
import TextAreaInput from '../../components/inputs/TextAreaInput';
import TextInput from '../../components/inputs/TextInput';
import LoaderButton from '../../components/LoaderButton';
import Responsive from '../../components/Responsive';
import { getBoundingClientRect } from '../../utils/functions';
import { translate } from '../../utils/useful';
import MultiStage from './MultiStage';
import CAHeader from '../../components/header/CAHeader';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import DiagramPath from '../../components/views/diagram/DiagramPath';
import PermissionsView from '../../components/PermissionsView';
import HttpServices from '../../utils/Http.services';

class CAMultiStage extends React.Component {
    state = {
        // stages: [
        //     { id: `${nanoid()}`,fistStage:true, name: '{{lang}}Not started', color: { background: 'rgb(224,233,255)', text: '#000' } },
        //     { id: `${nanoid()}`, name: '{{lang}}In progress' },
        //     { id: `${nanoid()}`, name: '{{lang}}Finished' },

        // ],\

        paths: [],

        // rawStages: [
        //     { id: 0, to: [1], name: '{{lang}}Trigger', type: 'trigger', color: { background: 'rgb(224,233,255)', text: '#000' } },
        //     { id: 1, to: [2,], name: '{{lang}}Not started', color: { background: 'rgb(224,233,255)', text: '#000' } },
        //     { id: 2, to: [4, 3], name: '{{lang}}In progress', color: { background: 'rgb(254,231,205)', text: '#000' } },
        //     { id: 3, to: [6, 7, 5], name: '{{lang}}Stage3', color: { background: 'rgb(254,226,242)', text: '#000' } },
        //     { id: 4, to: [9], name: '{{lang}}Stage4', color: { background: '#F3D7CA', text: '#000' } },
        //     { id: 5, to: [9], name: '{{lang}}Stage5', color: { background: '#D2E9E9', text: '#000' } },
        //     { id: 6, to: [9], name: '{{lang}}Stage6', color: { background: '#D5F0C1', text: '#000' } },
        //     { id: 7, to: [8], name: '{{lang}}Stage7', color: { background: '#AAD9BB', text: '#000' } },
        //     { id: 8, to: [9], name: '{{lang}}Stage8', color: { background: '#F5E8DD', text: '#000' } },
        //     { id: 9, to: [10], name: '{{lang}}Finished', color: { background: '#F1EAFF', text: '#000' } },
        //     { id: 10, name: '{{lang}}Archive', color: { background: '#D2E9E9', text: '#000' } },
        // ],

        rawStages: [
            { id: 0, to: [1], name: '{{lang}}Trigger', type: 'trigger', key: 'onFormSubmit', color: { background: 'rgb(224,233,255)', text: '#000' } },

            { id: 1, to: [2], name: '{{lang}}Not started', color: { background: 'rgb(224,233,255)', text: '#000' } },
            { id: 2, to: [9], name: '{{lang}}In progress', color: { background: 'rgb(254,231,205)', text: '#000' } },
            // { id: 3, to: [4], name: '{{lang}}Stage3', color: { background: 'rgb(254,226,242)', text: '#000' } },
            // { id: 4, to: [5], name: '{{lang}}Stage4', color: { background: '#F3D7CA', text: '#000' } },
            // { id: 5, to: [9], name: '{{lang}}Stage5', color: { background: '#D2E9E9', text: '#000' } },
            // { id: 6, to: [9], name: '{{lang}}Stage6', color: { background: '#D5F0C1', text: '#000' } },
            // { id: 7, to: [8], name: '{{lang}}Stage7', color: { background: '#AAD9BB', text: '#000' } },
            // { id: 8, to: [9], name: '{{lang}}Stage8', color: { background: '#F5E8DD', text: '#000' } },
            { id: 9, name: '{{lang}}Finished', color: { background: '#F1EAFF', text: '#000' } },
            // { id: 10, name: '{{lang}}Archive', color: { background: '#D2E9E9', text: '#000' } },
        ],

        stages: [],
        stageName: '',
        headers: [
            { key: 'name', type: 'TextInput', col: 6, information: { label: '{{lang}}Name', placeholder: '{{lang}}Name', required: true } },

            { key: 'color', type: 'AdvancedColorInput', col: 6, information: { label: '{{lang}}Color', placeholder: '{{lang}}Choose color', required: false } },
            // { key: 'timeline2', type: 'TextInput', information: { label: '{{lang}}desk.timeline', placeholder: '{{lang}}desk.timeline', required: false } },
            { key: 'type', type: 'SelectInput', col: 6, information: { label: '{{lang}}Stage type', defaultValue: 'neutral', type: "local", items: [{ value: 'neutral', title: '{{lang}}Neutral', }, { value: 'success', title: '{{lang}}Success', }, { value: 'fail', title: '{{lang}}Fail', }], placeholder: 'Choose...', required: false } },

            { key: 'statuses', type: 'TextInput', col: 6, information: { label: '{{lang}}Stage statuses', placeholder: '{{lang}}Select', required: false } },

            { key: 'highlights', type: 'TextInput', col: 6, information: { label: '{{lang}}Highlighed fields', placeholder: '{{lang}}Select', help: 'You can hightlight some fields for this stage so they will be shown on top of the form.', required: false } },

            { key: 'stageToGo', type: 'TextInput', col: 6, information: { label: '{{lang}}Stages to go', placeholder: '{{lang}}Select', help: 'You can hightlight some fields for this stage so they will be shown on top of the form.', required: false } },


            { key: 'permissionsType', type: 'SelectInput', col: 6, information: { label: '{{lang}}Permissions type', defaultValue: 'follow', type: "local", items: [{ value: 'follow', title: '{{lang}}Follow collection permissions', }, { value: 'custom', title: '{{lang}}Custom permissions for this stage', }], placeholder: 'Choose...', required: true } },


            // { key: 'permissions', type: 'TextInput', col: 6, information: { label: '{{lang}}Permissions', placeholder: '{{lang}}Select', required: true } },

        ],

        actionList: [
            { title: '{{lang}}ca.Success', key: 'success', icon: "/assets/icons/hand.thumbsup.fill.svg" },
            { title: '{{lang}}ca.Stuck', key: 'stuck', icon: "/assets/icons/hand.raised.fill.svg" },
            { title: '{{lang}}ca.Cancel', key: 'cancell', icon: "/assets/icons/hand.thumbsdown.fill.svg" },
            { title: '{{lang}}ca.Needs', key: 'needs', icon: "/assets/icons/rectangle.and.hand.point.up.left.fill.svg" },
            { title: '{{lang}}ca.Archive', key: 'archive', icon: "/assets/icons/folder.fill.badge.person.crop.svg" }
        ],
        data: {},
        components: {},


    }

    componentDidMount() {
        let data = this.props.initData
        // console.log('data.collectionInfo', data.collectionInfo)
        if (Array.isArray(data.collectionInfo?.stages)) {
            this.setState({ rawStages: data.collectionInfo?.stages, stages: data.collectionInfo?.stages })
        } else {
            this.setState({ stages: this.state.rawStages })
        }
        // permissionsObject
        if (this.props.setHeader) {
            let obj = {
                'toolbar': null,
                'showToolbar': false,
                isPortal: true, doNotshowNotification: true,
                'title': this.props.customHeader ?? (this.props.preTitle ? (this.props.preTitle + ' | ') : '') + translate('Stages'),
                create: true,
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.lastStage()
            }

            if (this.props.hasHeaderName) {
                obj.headerIdentityComponent = this.headerIdentityComponent
            }
            this.props.setHeader(obj)

        }

        setTimeout(() => {
            this.createStagesHiarchie()
        }, 10);

        // console.log(this.props.initRolesPermissions)
        // console.log('this.props.initData?.frames',this.props.initData?.frames)

        let initData = JSON.parse(JSON.stringify(this.props.initData ?? {}))
        // initData?.permissions?.admins.map((admin) => {
        //     for (let index = admin.permissions.length - 1; index >= 0; index--) {
        //         if (admin.permissions[index].id == 'applet') {
        //             admin.permissions.splice(index, 1)
        //         }
        //     }
        // })


        let frames = this.props.data?.frames


        this.setState({ admins: this.props.initRolesPermissions, frames: frames, flowName: this.props.flowName }, () => {
            // console.log('.admins', this.state.admins)
            if (!this.props.initRolesPermissions) {
                this.getFrameAdmins()
            }
            this.props.setHeader("dummy", 1)

        })
        // console.log(this.props.initData?.permissions?.admins)
    }
    getFrameAdmins = () => {
        let body = { applet: this.props.variables.appletId, unify: true }
        HttpServices.request('getAppletRoles', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            // console.log('adminstl', fetchResult)
            this.setState({ admins: fetchResult.info })

        })
    }
    headerIdentityComponent = () => {
        return (
            <div className='' >
                <input type="text" onChange={(e) => this.setName(e.target.value)} required={true} value={this.state.flowName} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Insert name ...')} />
            </div>
        )
    }
    setName = (value) => {
        this.setState({ flowName: value }, () => {
            this.props.setHeader("dummy", 1)
        })
    }
    lastStage = () => {
        if (this.props.customBackAction) {
            this.props.customBackAction()
        } else {
            this.props.lastStage()
        }
    }

    createStagesHiarchie = (cb) => {
        let inList = []
        let finalHiarchie = []


        let stages = JSON.parse(JSON.stringify([...this.state.stages]))
        let rawStages = JSON.parse(JSON.stringify([...this.state.stages]))

        let parent

        // console.log("111", JSON.parse(JSON.stringify([...this.state.stages])))


        for (let i = 0; i < stages.length; i++) {
            const element1 = stages[i];
            let found = false
            for (let index = 0; index < stages.length; index++) {
                const element2 = stages[index];
                if (element2.to && element2.to.includes(element1.id)) {
                    found = true
                }
            }
            if (!found) {
                // console.log("element1 ,", element1)

                parent = element1

            }
        }

        // console.log("START ,", stages)
        // console.log("parent ,", parent)

        // this.createParents(stages, parent)
        // console.log(parent)
        this.findParents(parent, stages)
        this.findSibilingLevel(stages)


        let hiarchie = { stage: parent, children: [] }

        this.getStageChildren(parent, hiarchie.children, stages, inList)



        finalHiarchie.push(hiarchie)



        this.setState({ finalHiarchie, stages: rawStages }, () => {
            setTimeout(() => {
                this.createPaths(stages, () => {
                    if (cb) {
                        cb()
                    }
                })


            }, 20);
        })
    }



    createPaths = (stages, cb) => {

        // let stages = this.state.stages
        let paths = []
        let containerBound = getBoundingClientRect(this.container)
        let bounds = {}

        for (let index = 0; index < stages.length; index++) {
            const stage = stages[index];
            let component = this['component-' + stage.id]
            if (component) {

                let bound = getBoundingClientRect(component)
                bounds[stage.id] = bound
                // console.log(bound)
            }
        }

        let scrollLeft = this.container.scrollLeft
        let scrollTop = this.container.scrollTop


        for (let index = 0; index < stages.length; index++) {
            const stage = stages[index];
            let start = [(bounds[stage.id]?.left + bounds[stage.id]?.width - containerBound.left) + scrollLeft, (bounds[stage.id]?.top + (bounds[stage.id]?.height / 2) - containerBound.top) + scrollTop]
            let SCKey = stage.id


            if (Array.isArray(stage.to)) {
                for (let j = 0; j < stage.to.length; j++) {
                    const to = stage.to[j];
                    let end = [bounds[to]?.left - containerBound.left - 1 + scrollLeft, (bounds[to]?.top + (bounds[to]?.height / 2) - containerBound.top + scrollTop)]
                    let ECKey = to

                    if (end && start) {
                        paths.push({ ECKey, SCKey, start, end, startOffset: [0, 0], endOffset: [0, 0] })
                    }
                }
            }


        }



        this.setState({ paths }, () => {
            cb()
        })
        // console.log(paths)

    }

    // createParents = (stages, parent) => {

    //     this.findParents(parent,stages)
    //     // for (let i = 0; i < stages.length; i++) {
    //     //     const stage = stages[i];
    //     //     let parents = []
    //     //     stages[i].parents = parents
    //     // }

    // }


    findSibilingLevel = (stages) => {
        for (let i = 0; i < stages.length; i++) {
            let stage = stages[i];

            if (stage.parents?.length > 1) {
                let oneParent = stage.parents[0]

                for (let j = 0; j < oneParent.length; j++) {
                    const oneStage = oneParent[j];
                    let found = true

                    for (let k = 0; k < stage.parents.length; k++) {
                        const otherParent = stage.parents[k];
                        if (!otherParent.includes(oneStage)) {
                            found = false
                        }
                    }

                    if (found) {

                        let isParent = false
                        for (let m = 0; m < stages.length; m++) {
                            const parentStage = stages[m];
                            if (parentStage.id == oneStage && parentStage.to.includes(stage.id)) {
                                isParent = true
                            }
                        }


                        // if (!isParent) {


                        stage.sibiling = oneStage
                        // }
                    }
                }

            }

        }


        for (let i = 0; i < stages.length; i++) {
            let stage = stages[i];

            if (stage.sibiling) {

                for (let j = 0; j < stages.length; j++) {
                    let otherStage = stages[j];

                    if (stage.sibiling == otherStage.id) {
                        if (!otherStage.sibilings) {
                            otherStage.sibilings = []
                        }
                        otherStage.sibilings.push({ stage, children: [] })
                    }


                }

            }
        }
    }

    findParents = (cStage, stages) => {

        // console.log("findParents")
        // console.log(cStage)

        if (cStage) {
            for (let i = 0; i < stages.length; i++) {
                let stage = stages[i];

                // console.log(stage.to)
                // console.log(cStage)

                if (Array.isArray(stage.to) && stage.to.includes(cStage.id)) {

                    if (!cStage.parents) {
                        cStage.parents = []
                    }
                    if (!stage.parents || stage.parents.length == 0) {
                        cStage.parents.push([stage.id])

                    } else {
                        for (let j = 0; j < stage.parents.length; j++) {

                            const mpath = stage.parents[j];
                            // let found = false

                            if (Array.isArray(mpath)) {

                                // let nParent = [...mpath, stage.id]
                                // for (let k = 0; k < cStage.parents.length; k++) {
                                //     const pparent = cStage.parents[k];
                                //     if (String(pparent) == String(nParent)) {
                                //         found = true
                                //     }
                                // }
                                // if (!found) {
                                cStage.parents.push([...mpath, stage.id])
                                // }


                            }

                        }
                    }
                }

                if (Array.isArray(cStage.parents)) {
                    let stageParents = [...cStage.parents]
                    cStage.parents = []

                    for (let m = 0; m < stageParents.length; m++) {
                        const element1 = stageParents[m];
                        let found = false
                        for (let n = 0; n < stageParents.length; n++) {
                            const element2 = stageParents[n];

                            if (m != n) {
                                found = element1.every(v => element2.includes(v))
                            }
                        }
                        if (!found) {
                            cStage.parents.push(element1)
                        }

                    }
                }
            }

            if (Array.isArray(cStage.to)) {
                for (let i = 0; i < cStage.to.length; i++) {
                    const stage = cStage.to[i];
                    for (let j = 0; j < stages.length; j++) {
                        const element = stages[j];
                        if (stage == element.id) {
                            this.findParents(element, stages)
                        }
                    }
                }
            }
        }

    }



    getStageChildren(parent, hiarchie, stages, inList) {
        if (parent && parent.to) {

            for (let i = 0; i < stages.length; i++) {
                const element = stages[i];


                if (parent.to.includes(element.id)) {

                    if (!inList.includes(element.id) && (element.sibiling == null)) {
                        inList.push(element.id)
                        let myHiarchie = { stage: element, children: [] }

                        this.getStageChildren(element, myHiarchie.children, stages, inList)


                        // if (element.sibiling == parent.id) {
                        //     let sibiling = { stage: element, children: [], }

                        //     this.getStageChildren(element, myHiarchie.children, stages, inList)
                        //     if (!parent.sibilings) {
                        //         parent.sibilings = []
                        //     }
                        //     parent.sibilings.push(sibiling)
                        // }

                        // console.log("myHiarchie",myHiarchie)

                        hiarchie.push(myHiarchie)

                    }
                }

            }
        }

        if (parent?.sibilings) {
            for (let i = 0; i < parent.sibilings.length; i++) {
                let thisStage = parent.sibilings[i];
                this.getStageChildren(thisStage.stage, thisStage.children, stages, inList)
                // console.log(thisStage)
            }
        }
    }




    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static',
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                {!this.props.hideMore && (
                    <button onClick={() => this.plusFixedView.showView()} ref={el => this.plusBut = el} className="br-30 flexcc" style={{ backgroundColor: '#fff', height: 30, width: 30 }}>
                        <img src="/assets/icons/useful/more.png" className="rorate-90" height={20} />
                    </button>
                )}

                <FixedView width={this.props.width} zIndex={10} ref={el => this.plusFixedView = el} nodeRef={this.plusBut} xOffset={-7} bottomOffset={this.props.fullSize ? -7 : 0} topOffset={7} maxWidth={180} >
                    <div className='bg-white br-10 py-2 px-3 shadow-3 sc-gray2 d-flex flex-column'>


                        <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.openEditModal(this.props.initData)}>
                            <img src='/assets/icons/useful/star (9).png' height={15} alt='' />
                            <p className="text-smaller text-semibold px-1  ">{translate('Make as default')}</p>
                        </button>

                        <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.convertToAdvance(this.props.initData)}>
                            <img src='/assets/icons/useful/directions.png' height={15} alt='' />
                            <p className="text-smaller text-semibold px-1  ">{translate('Convert to advance')}</p>
                        </button>

                        <div className="w-100 my-2" style={{ height: 1, background: "#eee" }}>

                        </div>

                        <button className="w-100 p-0 text-start flexc mt-1 mb-2" onClick={() => { this.plusFixedView.hideView(); this.diagramVariablesSidebar.open() }}>
                            <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                            <p className="text-smaller text-semibold px-1  ">{translate('Open variables')}</p>

                        </button>

                    </div>
                </FixedView>
                <div className='px-2'>

                    <ButtonAnimated
                        iconwidth='24px'
                        onClick={this.nextStage}
                        isLoading={this.state.isLoading}
                        title={this.props.customButtonTitle ?? translate("ca.Continue")}
                        icon='/assets/icons/angle-right-white2.svg'
                        textColor={'#222'}
                        invert={!this.props.colors?.iconInvert}
                        bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                    />
                </div>

            </div>

        )
    }


    componentWillUnmount() {
    }


    nextStage = (rawData) => {

        console.log("nextStage", this.state.flowName)
        console.log("nextStage", this.props.customButtonAction)

        if (this.props.customButtonAction && this.state.flowName.trim() != '') {
            this.props.customButtonAction(this.state.flowName, this.state.stages)
        } else {

            let data = this.props.initData
            if (!data.collectionInfo) {
                data.collectionInfo = {}
            }

            console.log(this.state.stages)

            data.collectionInfo.automations = this.state.stages
            this.props.setData(data, () => {

                if (this.props.continue) {
                    this.props.continue(this.props.stageName)
                } else {
                    this.props.changeStage('userPrespective')
                }

            })
        }


    }


    onDragEnd = (result) => {
        let items = Array.from(this.state.stages);
        let [reorderItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderItem);
        this.setState({ stages: items }, () => {
        });
    };
    selectHandler = (item) => {
        let defaultt = this.state.stages;
        defaultt.push(item);
        this.makeList()
        this.setState({ stages: defaultt }, this.createStage.hideView());
    };
    makeList = () => {
        let defaultt = this.state.stages
        let stages = []
        this.props.headers.forEach(e => {
            if (!defaultt.includes(e)) {
                if (!stages.includes(e)) {
                    stages.push(e)

                }
            }
        });
        this.setState({ stages })

    }



    addStage = () => {
        let id = nanoid()
        let stages = JSON.parse(JSON.stringify([...this.state.stages]))
        let lastStage

        // console.log(JSON.parse(JSON.stringify(stages)))

        for (let i = 0; i < stages.length; i++) {
            const element = stages[i];
            if (element.to == null || element.to.length == 0) {
                lastStage = element
            }

        }

        // console.log("lastStage", lastStage)
        let to = Array.isArray(lastStage.to) ? lastStage.to : []
        to.push(id)
        lastStage.to = to

        let name = '{{lang}}Stage ' + (stages.length + 1)

        stages.push({ id: `${id}`, name, to: [] })

        // console.log("stages !!!! ", stages)
        // let stages = this.state.stages

        this.setState({ stages: stages }, () => {
            this.createStagesHiarchie()
            setTimeout(() => {
                this.container.scrollTo({ left: this.container.scrollWidth, behavior: "smooth", })
            }, 300);
        })
    }



    removeCurrentStage = () => {
        let currentStage = this.state.currentStage
        let stages = this.state.stages
        let foundIndex

        stages.forEach((stage, index) => {
            if (stage.id == currentStage.id) {
                foundIndex = index
            }
        })

        if (foundIndex != null) {
            stages.splice(foundIndex, 1)
        }


        for (let i = 0; i < stages.length; i++) {
            let stage = stages[i];
            if (!Array.isArray(stage.to)) {
                stage.to = []
            }

            if (stage.to.includes(currentStage.id)) {
                stage.to = stage.to.filter((a) => a != currentStage.id)
                let to = currentStage.to ?? []
                stage.to = this.uniqueById([...stage.to, ...to])
            }

        }


        this.setState({ currentStage: null, stages }, () => {
            this.createStagesHiarchie()
        })
    }


    uniqueById(items) {
        const set = new Set();
        return items.filter((item) => {
            const isDuplicate = set.has(item.id);
            set.add(item.id);
            return !isDuplicate;
        });
    }


    stagePathDrop = (path) => {

        let stages = this.state.stages
        let draggingStage = this.state.draggingStage

        for (let i = 0; i < stages.length; i++) {
            let stage = stages[i];
            if (!Array.isArray(stage.to)) {
                stage.to = []
            }

            if (stage.to.includes(draggingStage.id)) {
                stage.to = stage.to.filter((a) => a != draggingStage.id)
                let to = draggingStage.to ?? []
                stage.to = [...stage.to, ...to]
            }

            if (stage.id == path.SCKey) {
                stage.to = stage.to.filter((a) => a != path.ECKey)
                stage.to.push(draggingStage.id)
            }

            if (stage.id == draggingStage.id) {

                stage.to = []
                stage.to.push(path.ECKey)

            }


            // if (stage.id == path.ECKey) {

            // }

        }


        this.setState({ stages: stages, draggingStage: null, ghost: null }, () => {
            this.createStagesHiarchie()
        })
        // console.log("stages!",stages)
        // console.log(draggingStage)

    }



    changeValue = (event, index) => {
        let stages = this.state.stages
        stages[index].name = event.target.value
        this.setState({ stages })
    }
    setData = (key, value) => {
        let defaultt = this.state.stages
        for (let i = 0; i < defaultt.length; i++) {
            if (defaultt[i].id == key.id) {
                defaultt.splice(i, 1, value)
                break
            }
        }
        this.setState({ stages: defaultt })

    }
    addActions = (key, index) => {

        let stages = this.state.stages
        stages[index].type = key
        this.setState({ stages })
    }
    // removeItem(index) {
    //     const stages = [...this.state.stages];
    //     stages.splice(index, 1);
    //     this.setState({ stages });
    // }

    setStage = (item) => {

        // this.setState({ currentStage: null }, () => {
        // console.log("setStage", item)

        this.createStagesHiarchie(() => {
            
            this.setState({ currentStage: null }, () => {

                this.setState({ currentStage: item.stage }, () => {

                    let infoSectionBound = getBoundingClientRect(this.infoSection)
                    setTimeout(() => {

                        this.pageContainer.scrollTo({ top: (infoSectionBound.top - 200), behavior: 'instant', })
                    }, 1);
                })
            })

        })
        // })
    }


    formLiveChange = (data, init, key, value, extra, full) => {
        if (!init) {
            let currentStage = this.state.currentStage
            let stages = this.state.stages
            let currentStageIndex

            // console.log('currentStage', JSON.parse(JSON.stringify(currentStage)),this.state.admins)
            // console.log('formLiveChangedata',data,value)

            if (key == 'permissionsType' && value == 'custom' && !currentStage.admins && currentStage[key] != 'custom') {

                currentStage.admins = this.state.admins ? JSON.parse(JSON.stringify(this.state.admins)) : null
            }

            currentStage[key] = value

            stages.forEach((stage, index) => {
                if (stage.id == currentStage.id) {
                    currentStageIndex = index
                }
            });

            // console.log("currentStageIndex",currentStageIndex)

            if (currentStageIndex) {
                stages[currentStageIndex] = currentStage

                // console.log(stages)
                this.setState({ currentStage, stages })
            }
        }
    }

    onDragStage = (e) => {
        if (this.ghost) {


            this.ghost.style.top = (e.clientY - 10 - this.state.cornerBound.top) + 'px'
            this.ghost.style.left = e.clientX + 2 - this.state.cornerBound.left + 'px'

        }
    }

    stageDragStart = (e, stage) => {

        // e.preventDefault()
        const dragEle = e.target;

        const ghostEle = dragEle.cloneNode(true);

        const nodeRect = dragEle.getBoundingClientRect();

        // ghostEle.style.position = 'absolute'
        ghostEle.style.top = e.clientY - nodeRect.top
        ghostEle.style.left = e.clientX - nodeRect.left



        // console.log(ghostEle)

        let dragImg = new Image(0, 0);
        dragImg.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        dragImg.style.cursor = 'move'

        let cornerBound = getBoundingClientRect(this.cornerIndicator)

        this.setState({ cornerBound, ghost: ghostEle, draggingStage: stage, ghostBound: nodeRect }, () => {
            this.ghost.replaceChildren(ghostEle);
        })


        e.dataTransfer.setDragImage(dragImg, 0, 0);



        // document.appendChild(ghostEle)
        // e.dataTransfer.setDragImage(
        //     null,

        // );

        // e.preventDefault()
        // console.log(e)
        // var crt = this.cloneNode(true);

        // console.log(crt)

        // crt.style.backgroundColor = "red";
        // e.dataTransfer.setDragImage(crt, 0, 0);
    }

    stageDragEnd = (e) => {
        this.setState({ ghost: null, draggingStage: null })
    }


    renderSection(hiarchie) {

        if (hiarchie && Array.isArray(hiarchie)) {

            return (
                <div className='d-flex  align-items-center'>
                    <div className='d-flex flex-column ' style={{ justifyContent: 'space-between' }}>
                        {hiarchie.map((item, index) => {
                            let isDragging = this.state.draggingStage?.id == item.stage?.id
                            let data = item.stage
                            if (item.stage?.id == this.state.currentStage?.id) {
                                data = this.state.currentStage
                            }
                            // console.log(item)
                            return (
                                <div key={item.id ?? item?.stage?.id} className='d-flex w-100 ' style={{ marginTop: 1, marginBottom: 1 }} >
                                    {item.stage?.type == 'trigger' ? (

                                        <div id={'component-' + item.stage?.id} ref={el => this['component-' + item.stage?.id] = el} className='flexc  mr-4 my-1 position-relative ' >
                                            <div className="flexcc br-30" style={{ width: 40, minHeight: 40, backgroundColor: '#eee', border: '1px dashed #ccc', }}   >

                                                <img className='' src="/assets/icons/useful/stack1.png" height={26} />

                                            </div>
                                        </div>

                                    ) : (
                                        <div id={'component-' + item.stage?.id} ref={el => this['component-' + item.stage?.id] = el} className='flexc  mr-4 my-1 position-relative ' style={{}} onClick={() => this.setStage(item)}>
                                            <div className="flexcb br-8" draggable={"true"} onDrag={(e) => this.onDragStage(e)} onDragEnd={(e) => this.stageDragEnd(e)} onDragStart={(e) => this.stageDragStart(e, item.stage)} style={{ width: 140, cursor: 'move', backgroundColor: isDragging ? '#007aff30' : (data?.color?.background ?? '#fff'), color: data?.color?.text ?? '#000', border: isDragging ? '1px dashed #007aff' : '1px solid #f0f0f0', borderColor: isDragging ? "#007aff" : this.state.currentStage?.id == item.stage?.id ? '#007aff' : '#f0f0f0' }}   >
                                                {/* <div className='mld-4'>
                                        <img className='flexcc' src='/assets/icons/dragicon.svg' />
                                         </div> */}
                                                <div className='w-100' style={{ opacity: isDragging ? 0.2 : null }}>
                                                    <MultiStage index={index} changeValue={this.changeValue} addActions={this.addActions} data={data} actionList={this.state.actionList} />
                                                </div>
                                                {/* <button className="px-2" onClick={() => this.removeItem(index)}>
                                        <img className="flexcc opacity-hover" src="/assets/icons/trash-red.svg" />
                                         </button> */}
                                            </div>

                                            {/* <div style={{ height: "100%", border: '18px solid transparent', borderLeft: '10px solid', borderLeftColor: item.color?.background ?? '#fff' }}>

                                     </div> */}
                                        </div>
                                    )}

                                    {(item.children?.length > 0) && (

                                        this.renderSection(item.children)
                                    )}

                                    {/* {console.log(item)} */}
                                    {(item.stage?.sibilings?.length > 0) && (

                                        this.renderSection(item.stage?.sibilings)
                                    )}



                                </div>
                            )
                        })}

                    </div>

                </div>
            )



        }

    }

    // dragOverPath = (e) => {
    //     // console.log(e)
    // }



    renderPaths = () => {
        return this.state.paths.map((prop, index) => {
            return (
                <>
                    <DiagramPath hasDropEffect={true} hideCut={true} pathColor={'#e0e0e0'} removePath={this.removePath} ref={el => this[prop.key] = el} key={prop.id} data={prop} draggingId={this.draggingId} dragEnd={this.dragEnd} onDrag={this.onDrag} onDragStart={this.onDragStart} zoom={this.state.zoom} onDrop={this.stagePathDrop} />
                </>
            )
        })
    }


    scrollIndicatorOver = (side, value) => {

        this.container[side] = this.container[side] + value

    }


    setAdmins = (admins, cb) => {

        // console.log('setAdmins',admins)
        let currentStage = this.state.currentStage
        let stages = this.state.stages

        currentStage.admins = admins
        let currentStageIndex

        stages.forEach((stage, index) => {
            if (stage.id == currentStage.id) {
                currentStageIndex = index
            }
        });

        // console.log("currentStageIndex",currentStageIndex)

        if (currentStageIndex) {

            stages[currentStageIndex] = currentStage
            this.setState({ currentStage, stages })


            this.setState({ currentStage }, () => {
                // console.log('admins',admins)
                // console.log(this.state.currentStage)
                if (cb) {
                    cb()
                }
            })
        }
    }


    setPermissionsObject = (permissionsObject, cb) => {

        this.setState({ permissionsObject }, () => {
            if (cb) {
                cb()
            }
        })

    }




    render() {
        // let Ghost = this.state.ghost
        // console.log(this.state.finalHiarchie)
        return (

            <div ref={el => this.pageContainer = el} className='h-100 w-100 window-content-radius scroll-no-scrollbar' style={{ backgroundColor: "#fff", position: 'relative', borderBottomRightRadius: '10px' }}>
                {/* <div style={{ position: 'relative', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} />
                </div> */}

                <div className='corner-indicator' ref={el => this.cornerIndicator = el}></div>

                <div className='w-100 flexc flex-column'>
                    <div className='py-3 w-100' style={{ maxWidth: 1000 }}>

                        <div className='d-flex flex-column flex-wrap w-100'>
                            {/* <div className=''>
                            <p className='font-size-18 weight-500 main-text1'>{translate('ca.The text blow Title')}</p>
                            <p className='mt-1 font-size-13' style={{ color: "#888" }}>{translate('ca.text-below-title-description')}</p>
                            </div> */}
                            <div className='px-3 w-100'>
                                <div className='px-0 pt-3 mb-3' style={{}}>
                                    <h2 className=" text-semibig mb-0 color-dark-blue-1" >{translate('Flow stages')}</h2>
                                    <p className="mt-1 text-small color-dark-blue-1 max-width-500" >{translate("You can create permissions and privilates for each stage. These stages help ypu to manage your workflows.")}</p>
                                </div>


                                <div className='px-2  br-8 mt-3 w-100' style={{ background: "#fff", border: '1px solid #f0f0f0' }}>

                                    <div className="flexc w-100 position-relative" >
                                        <div ref={el => this.container = el} className="flexc w-100 py-4 position-relative" style={{ overflow: 'auto' }}>


                                            {this.renderSection(this.state.finalHiarchie)}
                                            <div className='position-absolute top-0 left-0'>
                                                {this.renderPaths()}
                                            </div>

                                            {this.state.ghost && (
                                                <div className="ghost br-10 " ref={el => this.ghost = el} style={{ padding: 1, width: 'auto', pointerEvents: 'none', height: 'auto', overflow: 'hidden', backgroundColor: '#ffffffcc', boxShadow: '0px 0px 15px #00000010', zIndex: 6, position: 'fixed', transform: 'rotate(-5deg) translate(45px, 15px)', cursor: 'move' }}>

                                                </div>

                                            )}


                                            <div className='d-flex mld-1 mrd-5' style={{ justifyContent: "end" }}>

                                                <button onClick={this.addStage} className='br-30 flexcc mrd-5' style={{ height: 30, width: 30, background: 'linear-gradient(90deg, #007aff, #007aff' }}>
                                                    <img src='/assets/icons/plus-white.svg' height={20} alt="" />
                                                </button>
                                                {/* <ButtonAnimated
                                                iconwidth='24px'
                                                onClick={this.addStage}
                                                // title={translate("ca.Add Stage")}
                                                icon='/assets/icons/plus-white.svg'
                                                textColor={'#fff'}
                                                bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                            /> */}

                                            </div>








                                        </div>

                                        {this.state.ghost && (
                                            <>
                                                <div onDragOver={() => this.scrollIndicatorOver('scrollLeft', -1)} style={{ height: '100%', width: 20, position: 'absolute', top: 0, left: 0, zIndex: 10, }}></div>
                                                <div onDragOver={() => this.scrollIndicatorOver('scrollTop', -1)} style={{ height: 20, width: '100%', position: 'absolute', top: 0, left: 0, zIndex: 10, }}></div>
                                                <div onDragOver={() => this.scrollIndicatorOver('scrollTop', 1)} style={{ height: 20, width: '100%', position: 'absolute', bottom: 0, left: 0, zIndex: 10, }}></div>
                                                <div onDragOver={() => this.scrollIndicatorOver('scrollLeft', 1)} style={{ height: '100%', width: 20, position: 'absolute', top: 0, right: 0, zIndex: 10, }}></div>
                                            </>
                                        )}

                                    </div>
                                </div>

                            </div>


                            {this.state.currentStage && (
                                <div className='pb-5' ref={el => this.infoSection = el}>
                                    <div className='px-3 pt-3 mb-3 flexcb' style={{}}>
                                        <p className=" text-semibig mb-0 text-bold" >{translate('Stage Configuration')}</p>

                                        <button onClick={() => this.removeCurrentStage()} className='px-2 py-1 mx-1 br-4' style={{ color: '#ee5050', border: '1px solid #ee5050' }}>
                                            <p className='text-semibold text-small'>{translate("Remove Stage")}</p>
                                        </button>
                                    </div>

                                    <div className='mt-2' >
                                        <div className='px-3'>
                                            <FormViewer ref={el => this.form = el} liveChange={this.formLiveChange} initData={this.state.currentStage} headers={this.state.headers} errors={this.state.errors} inputClass={'bordered-input'} formClass={'bordered-form'} width={this.props.width} nopadding={true} />
                                        </div>

                                        {this.state.currentStage?.permissionsType == 'custom' && (
                                            <div>
                                                <div className='px-3'>
                                                    <p className='text-semibold text-normal'>{translate("Stage Permissions")}</p>
                                                    <p className=' text-smaller mt-1 color-gray-2' style={{ maxWidth: 500 }}>{translate("The following permissions will be applied for the selected stage. Default permission is based on the collection permissions.")}</p>
                                                </div>
                                                <PermissionsView frames={this.state.frames} width={this.props.width} admins={this.state.currentStage?.admins} setAdmins={this.setAdmins} permissionsObject={this.state.permissionsObject} setPermissionsObject={this.setPermissionsObject} type={'stage'} stage={this.state.currentStage} variables={this.props.variables} className={"px-3 mt-3"} />

                                            </div>
                                        )}
                                        <div>
                                        </div>

                                    </div>
                                </div>
                            )}


                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CAMultiStage;